import { Plugin } from "vue";
import { utils } from "@velites/vue-ext";
import elementPlusWidgets from "./elementPlus";
const requireContext = require.context(".", true, /^.*\/\w+\.widget\.vue/);

export default <Plugin>((app) => {
  app.use(elementPlusWidgets);
  utils.processRequireContextToComponents(app, [requireContext]);
});
